var _rect, _rect2, _path, _path2, _g, _g2, _rect3, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDgCs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_283",
    "data-name": "Group 283",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.536,
    height: 27.575,
    viewBox: "0 0 24.536 27.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 2.114,
    height: 8.209,
    transform: "translate(10.928 16.298) rotate(-0.113)",
    fill: "#b2bacc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 1.057,
    height: 8.204,
    transform: "translate(11.985 16.296) rotate(-0.113)",
    fill: "#bfc6d8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M266.863,518.641l23.539-.046a.482.482,0,0,1,.484.48h0l.032,16.479-24.5.049-.032-16.479A.483.483,0,0,1,266.863,518.641Zm22.532,1.268-21.378.042a.342.342,0,0,0-.34.342l.028,13.859a.341.341,0,0,0,.341.34l21.378-.042a.341.341,0,0,0,.339-.342l-.027-13.856a.341.341,0,0,0-.338-.344h0Z",
    transform: "translate(-266.382 -518.595)",
    fill: "#bfc6d8",
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M277.428,542.59l2.041,0,.585,3.207-3.337.007Z",
    transform: "translate(-266.382 -518.595)",
    fill: "#bfc6d8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M277.3,542.591l1.08,0,.007,3.256-1.771,0Z",
    transform: "translate(-266.382 -518.595)",
    fill: "#a5acbd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(9.682 26.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M276.278,545.567l4.068-.008a.217.217,0,0,1,.216.214v.252l-4.5.009v-.252A.216.216,0,0,1,276.278,545.567Z",
    transform: "translate(-276.064 -545.559)",
    fill: "#a2acbc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(9.683 27.431)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 4.498,
    height: 0.135,
    transform: "translate(0 0.009) rotate(-0.113)",
    fill: "#b2bacc"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 24.501,
    height: 0.324,
    transform: "translate(0.032 17.019) rotate(-0.113)",
    fill: "#b2bacc"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(0.673 0.709)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 23.117,
    height: 15.659,
    rx: 0.472,
    transform: "translate(0 0.046) rotate(-0.113)",
    fill: "#a2aaba"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    d: "M.256,0H20.681a.256.256,0,0,1,.256.256V13.413a.257.257,0,0,1-.257.257H.256A.256.256,0,0,1,0,13.414V.256A.256.256,0,0,1,.256,0Z",
    transform: "translate(1.759 1.609) rotate(-0.113)",
    fill: "#ebedf2",
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDgCs);
export default __webpack_public_path__ + "static/media/dg-cs.c726f8e975179eb39833d50d33f0f32f.svg";
export { ForwardRef as ReactComponent };